import type { TagItem } from '@/components/common/FormExpandableSection/FormExpandableSection';

export function getAppAndSiteChannelTags(channels?: string[]): TagItem[] {
  if (!channels || channels.length === 0) {
    return [];
  }

  return [{ label: `${channels.length} channel${channels.length !== 1 ? 's' : ''}` }];
}
